import { render, staticRenderFns } from "./ExploreDiscover.vue?vue&type=template&id=040edf5a&"
import script from "./ExploreDiscover.vue?vue&type=script&lang=js&"
export * from "./ExploreDiscover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports